export default __webpack_public_path__ + "static/media/651.33b6159c.jpg";